<div class="sleketon-loader-container">
  <table>
    <thead>
      <tr>
        @for (column of dataSkeleton.columns; track $index) {
          <td>
            <div class="skeleton-cell skeleton-cell--header"></div>
          </td>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of dataSkeleton.rows; track $index; let i = $index) {
        <tr>
          @for (column of dataSkeleton.columns; track $index; let y = $index) {
            <td>
              <div [style.width.%]="dataSkeleton.width[i][y]" class="skeleton-cell"></div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
